<template>
	<div v-if="!isSubmitted">
		<form :key="'PERSONAL_INFO'" @submit.prevent>
			<h1 :class="isInTest ? 'heading-4' : 'heading-3'" data-test="password-heading">Create a password</h1>
			<p class="text-color-content-secondary mt-50" :class="isInTest ? 'mb-150' : 'mb-200'">
				Set a secure password to create your account and save your responses.
			</p>
			<UserCreationForm
				:show-agreement-message="true"
				:show-password-field="true"
				:display-test-variant="isInTest"
				@user-submitted="submitCallback"
			/>
		</form>
	</div>
	<CheckoutSignupSuccessAnimation
		v-else
		:class="isInTest ? 'my-600' : 'px-600-md mt-600'"
		@on-complete="goToNextScreen"
		@on-fail="goToNextScreen"
	/>
</template>
<script setup lang="ts">
import CheckoutSignupSuccessAnimation from '@components/checkout/checkout-signup-success-animation.vue';
import { ref } from 'vue';
import UserCreationForm from '@components/user/user-creation-form.vue';
import { useRouter } from 'vue-router';
import { useSignupStore } from '@stores/signup';

const signupStore = useSignupStore();

const isSubmitted = ref(false);
const nextRoute = ref('');
const router = useRouter();

const isInTest = ref(false);

async function submitCallback(): Promise<void> {
	try {
		nextRoute.value = await signupStore.submitPassword();
		isSubmitted.value = true;
	} catch {}
}

async function goToNextScreen(): Promise<void> {
	await router.push({ name: nextRoute.value });
}

async function setup(): Promise<void> {
	try {
		isInTest.value = await signupStore.determineStreamlineSignupTestGroup();
	} catch {}
}

setup();
</script>
